import { render, staticRenderFns } from "./CorporateRegistrationPage.vue?vue&type=template&id=401004cc"
import script from "./CorporateRegistrationPage.vue?vue&type=script&lang=js"
export * from "./CorporateRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports